document.querySelectorAll('.js-countdown').forEach(container => {
    // endTime must be GMT timezone!
    const endTime = +container.dataset.endtime * 1000;

    if (!endTime) {
        return;
    }

    const placeholderD = container.querySelector('.js-countdown-days');
    const placeholderH = container.querySelector('.js-countdown-hours');
    const placeholderM = container.querySelector('.js-countdown-minutes');

    function update() {
        let d = 0;
        let h = 0;
        let m = 0;

        // GMT time now
        const currentTime = new Date(new Date().toUTCString()).getTime();

        // Time left in milliseconds
        const timeLeft = endTime - currentTime;

        // Get days, hours, minutes
        if (timeLeft > 0 ) {
            d = Math.floor(timeLeft / (1000 * 3600 * 24));
            h = Math.floor( (timeLeft - (d * (1000 * 3600 * 24))) / (1000 * 3600) );
            m = Math.floor( (timeLeft - (d * (1000 * 3600 * 24)) - (h * (1000 * 3600))) / (1000 * 60) );
        }

        if (placeholderD) {
            placeholderD.innerHTML = d;
        }
        if (placeholderH) {
            placeholderH.innerHTML = h;
        }
        if (placeholderM) {
            placeholderM.innerHTML = m;
        }

        setTimeout(() => {
            update();
        }, 10000);
    }

    update();
});
